/**
 * Keys that we use for session storage
 * TODO might be cromulent to add a typed wrapper around session storage but i dont think its worth the effort
 */
export enum SessionStorageKey {
  HasBeenInOnboarding = 'hasBeenInOnboarding',
}
